import { API_BASE_URL } from "../index";
import { getCookie } from "../helpers/CookieHandler";

const fetchTETCountries = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchTETCountries`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchTETLanguage = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchLanguage`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchTETRulesUserType = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchTETUserType`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchTETContentType = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchTETContentType`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const createTETProduct = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createNewTETProduct`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchTETProducts = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/fetchTETProducts`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchTETProductMap = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/fetchTETProductMap`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const updateTETProdMap = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateTETProdMap`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchTETContent = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/fetchTETContent`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const updateTETContent = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateTETContent`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchTETRule = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/fetchTETRule`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const createNewDraftTETRule = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createNewDraftTETRule`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const createTETContent = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createTETContent`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchUserTETContent = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}stability/fetchUserTETContent`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const saveTETDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/saveTETRule`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const publishTETDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/makeLiveTETRule`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const deleteTETDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/deleteDraftTETRule`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchUserTETProducts = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}stability/fetchUserTETProducts`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchUserTETRule = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}stability/fetchUserTETRule`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const makeDraftTETRule = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/makeDraftTETRule`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

//Product Management APIs
const fetchAllProducts = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/getProductList`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const getProductVisibiltyList = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/getProductVisibilityList`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const getMasterAndLocalProducts = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/getProductDetails`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const updateProductVisibility = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateProductVisiblility`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const updateProductIndications = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateProductIndications`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const exportTET = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/exportTET`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const exportProducts = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/exportProductIndications`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const exportPortalFunctionality = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/exportPortalFunctionality`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const updateExistingDetails = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateExistingProductDetails`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchAmiData = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/fetchAmiData`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const createNewAmiDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createNewAmiDraft `, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const createAmiDraft = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createAmiDraft `, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const deleteAmiDraft = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/deleteAmiDraft`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const publishAmiDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateAmiLive`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const saveAmiDraft = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateAmiDraft`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const copyOptions = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/amiCopyFromLive`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const copyData = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/copyFromAmi`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchAndSetImage = (id, successHandler, errorHandler) => {
  fetch(`${API_BASE_URL}contentManagement/getImages/${id}`)
    .then((response) => {
      if (!response.ok) throw new Error("Image not found");
      return response.blob();
    })
    .then(successHandler)
    .catch(errorHandler);
};

const uploadImage = (file, successHandler, errorHandler) => {
  if (!file) return;
  const csrfToken = getCookie("XSRF-TOKEN");
  const formData = new FormData();
  formData.append("image", file);
  fetch(`${API_BASE_URL}rest/admin/images/upload`, {
    method: "POST",
    body: formData,
    credentials: "include",
    headers: {
      "X-XSRF-TOKEN": csrfToken,
    },
  })
    .then((res) => res.text())
    .then(successHandler)
    .catch(errorHandler);
};

const removeImage = (id, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/images/delete/${id}`, {
    credentials: "include",
    method: "DELETE",
    headers: {
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const saveContentDraft = (
  payload,
  successHandler1,
  successHandler2,
  errorHandler
) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/saveNewPage`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => {
      if (resp.status === 200) {
        return resp.json().then(successHandler1);
      } else {
        successHandler2(resp);
      }
    })
    .catch(errorHandler);
};

const fetchTemplateLive = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/templateListLive`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchTemplateDraft = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/templateListDraft`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const deleteTemplate = (queryParams, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/deleteDraftContent`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    credentials: "include",
    method: "DELETE",
    headers: {
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const duplicateTemplate = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/duplicate`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const createContentDraft = (queryParams, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/createDraftContent`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    credentials: "include",
    method: "PUT",
    headers: {
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const fetchContentDraft = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/fetchDraftData`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    credentials: "include",
    method: "GET",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchContentLive = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}contentManagement/fetchContentLiveData`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, {
    method: "GET",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const publishContentDraft = (
  payload,
  successHandler1,
  successHandler2,
  errorHandler
) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/publishNewPage`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => {
      if (resp.status === 200) {
        return resp.json().then(successHandler1);
      } else {
        successHandler2(resp);
      }
    })
    .catch(errorHandler);
};
const fetchMenuList = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/fetchMenuList`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const saveMenuList = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/saveMenuList`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const getAuditHistory = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/auditHistory`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const exportAuditHistory = (payload, successHandler, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/exportAuditHistory`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then(successHandler)
    .catch(failure);
};

const saveTETCalculation = (payload, successHandler, errorHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}stability/calculate`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((resp) => {
      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status}`);
      }
      return successHandler();
    })
    .catch(errorHandler);
};

export const api_v2 = {
  fetchTETCountries,
  createTETProduct,
  fetchTETLanguage,
  fetchTETRulesUserType,
  fetchTETProducts,
  fetchTETProductMap,
  updateTETProdMap,
  fetchTETContentType,
  fetchTETContent,
  updateTETContent,
  fetchTETRule,
  createNewDraftTETRule,
  createTETContent,
  fetchUserTETContent,
  saveTETDraft,
  publishTETDraft,
  deleteTETDraft,
  fetchUserTETProducts,
  fetchUserTETRule,
  saveTETCalculation,
  makeDraftTETRule,
  fetchAllProducts,
  getProductVisibiltyList,
  getMasterAndLocalProducts,
  updateProductVisibility,
  updateProductIndications,
  exportTET,
  exportProducts,
  exportPortalFunctionality,
  updateExistingDetails,
  fetchAmiData,
  createNewAmiDraft,
  createAmiDraft,
  deleteAmiDraft,
  publishAmiDraft,
  saveAmiDraft,
  copyOptions,
  copyData,
  fetchAndSetImage,
  uploadImage,
  removeImage,
  saveContentDraft,
  fetchTemplateLive,
  fetchTemplateDraft,
  deleteTemplate,
  duplicateTemplate,
  createContentDraft,
  fetchContentDraft,
  publishContentDraft,
  fetchContentLive,
  fetchMenuList,
  saveMenuList,
  getAuditHistory,
  exportAuditHistory
};



// WEBPACK FOOTER //
// ./src/mi-app/NewIndex.api.js